module.exports = __webpack_public_path__ + "img/bg_main06_mask.14332c92.png";